// extracted by mini-css-extract-plugin
export default {"container":"Pea-z","innerContainer":"Qea-z","multipleLines":"Rea-z","heading":"Sea-z","content":"Tea-z","linkColor":"Uea-z"};